import React, { useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
    Collapse,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
} from '@mui/material';

import { toggleSideBar } from '../../store/actions/navActions';
import * as C from '../../services/constants';

import HomeIcon from '../../resources/images/home-icon.svg';
import ManageProgramIcon from '../../resources/images/manage-program.svg';
import AddIcon from '../../resources/images/icons8-plus-30.png';
import CustomerServiceIcon from '../../resources/images/customer-support.svg';
import extLinkIcon from '../../resources/images/external-link.svg';

const SideNav = ({ openGoalEditor,closeGoalEditor }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { navigation, program } = useSelector((state) => state);
    const sideNavRef = useRef(null);

    const open = navigation.openSideBar;

    useEffect(() => {
        const handleClickOutside = (event) => {
            // Exclude hamburger button from click outside detection
            const isHamburgerButton =
                event.target.closest('[data-testid="MenuIcon"]') ||
                event.target.closest('.MuiIconButton-root') ||
                event.target.closest('[aria-label="menu"]') ||
                event.target.closest('.hamburger-btn');

            if (
                open &&
                sideNavRef.current &&
                !sideNavRef.current.contains(event.target) &&
                !isHamburgerButton
            ) {
                dispatch(toggleSideBar(false));
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () =>
            document.removeEventListener('mousedown', handleClickOutside);
    }, [open, dispatch]);
    // const isPublished =
    //     program.programInfo.status === C.LOYALTY_PROGRAM_STATUS_PUBLISHED;
    // const openAdminPortal = () =>
    //     window.open(process.env.REACT_APP_CC_ADMIN_PORTAL, '_blank');

    const goToAddGoal = () => {
        dispatch(toggleSideBar(false));
        openGoalEditor && openGoalEditor(C.GOAL_TYPE_NEW);
    };

    const handleNavigation = (path) => {
            closeGoalEditor && closeGoalEditor();

        if (window.location.pathname === path && open) {
            dispatch(toggleSideBar(false));
        } else {
            navigate(path);
            dispatch(toggleSideBar(false));
        }
    };

    return (
        // <div className="component-container-root">
            <div
            ref={sideNavRef}
            className={`sidenav ${open ? 'open' : 'closed'}`}
            style={{
                background:
                    'linear-gradient(to bottom, #003DA5 2.6%, #46DB8C 100%)',
            }}
        >
            <List>
                <ListItem disablePadding sx={{ display: 'block' }}>
                    <ListItemButton
                        sx={{
                            minHeight: 48,
                            justifyContent: open ? 'initial' : 'center',
                            px: 2.5,
                        }}
                        onClick={() => handleNavigation('/')}
                    >
                        <ListItemIcon
                            sx={{
                                minWidth: 0,
                                mr: open ? 3 : 'auto',
                                justifyContent: 'center',
                            }}
                        >
                            <img src={HomeIcon} alt="home" />
                        </ListItemIcon>
                        {/* <Link to="/"> */}
                        <ListItemText
                            primary="Home"
                            sx={{ opacity: open ? 1 : 0 }}
                        />
                        {/* </Link> */}
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding sx={{ display: 'block' }}>
                    <ListItemButton
                        sx={{
                            minHeight: 48,
                            justifyContent: open ? 'initial' : 'center',
                            px: 2.5,
                        }}
                        onClick={() => handleNavigation('/nba2.0-dashboard')}
                    >
                        <ListItemIcon
                            sx={{
                                minWidth: 0,
                                mr: open ? 3 : 'auto',
                                justifyContent: 'center',
                            }}
                            // onClick={() => dispatch(toggleSideBar(true))}
                        >
                            <img src={ManageProgramIcon} alt="manage program" />
                        </ListItemIcon>
                        <ListItemText
                            primary="Manage NBA2.0 Program"
                            sx={{ opacity: open ? 1 : 0 }}
                        />
                    </ListItemButton>
                    {/* <Collapse in={open}> */}
                    {/* <List className="sub-menu"> */}
                    {/* <ListItem>
                                <Link to={isPublished ? '/manage-tiers' : '#'}>
                                    <ListItemText primary="Tiers" />
                                </Link>
                            </ListItem> */}
                    {/* <ListItem>
                                <Link to={isPublished ? '/manage-events' : '#'}>
                                    <ListItemText primary="Event Activities" />
                                </Link>
                            </ListItem> */}
                    {/* <ListItem>
                                <Link to={'/manage-rules'}>
                                    <ListItemText primary="Rules" />
                                </Link>
                            </ListItem> */}
                    {/* <ListItem>
                                <Link to={'/nba2.0-dashboard'}>
                                    <ListItemText primary="NBA2.0 Dashboard" />
                                </Link>
                            </ListItem> */}
                    {/* </List> */}
                    {/* </Collapse> */}
                </ListItem>
                <ListItem disablePadding sx={{ display: 'block' }}>
                    <ListItemButton
                        sx={{
                            minHeight: 48,
                            justifyContent: open ? 'initial' : 'center',
                            px: 2.5,
                        }}
                        onClick={()=>goToAddGoal()}
                    >
                        <ListItemIcon
                            sx={{
                                minWidth: 0,
                                mr: open ? 3 : 'auto',
                                justifyContent: 'center',
                            }}
                            // onClick={() => goToAddGoal()}
                        >
                            <img src={AddIcon} alt="Add Goal" />
                        </ListItemIcon>
                        <ListItemText
                            // onClick={goToAddGoal}
                            primary="Add Goal"
                            sx={{ opacity: open ? 1 : 0 }}
                        />
                    </ListItemButton>
                </ListItem>
                {/* <ListItem disablePadding sx={{ display: 'block' }}>
                    <ListItemButton
                        sx={{
                            minHeight: 48,
                            justifyContent: open ? 'initial' : 'center',
                            px: 2.5,
                        }}
                        onClick={openAdminPortal}
                    >
                        <ListItemIcon
                            sx={{
                                minWidth: 0,
                                mr: open ? 3 : 'auto',
                                justifyContent: 'center',
                            }}
                        >
                            <img
                                src={CustomerServiceIcon}
                                alt="customer service"
                            />
                        </ListItemIcon>
                        <ListItemText
                            primary="Customer Service"
                            sx={{ opacity: open ? 1 : 0 }}
                        />
                        <ListItemIcon
                            sx={{
                                minWidth: 0,
                                mr: open ? 3 : 'auto',
                                justifyContent: 'center',
                            }}
                            className="nav-external-link-icon"
                        >
                            <img src={extLinkIcon} alt="customer service" />
                        </ListItemIcon>
                    </ListItemButton>
                </ListItem> */}
            </List>
            </div>
        // </div>
        
    );
};

export default SideNav;
